{
  "data_records_grid": {
    "columns": "Colonnes"
  },
  "custom_objects": {
    "import_error": "Erreur d'importation",
    "export_all": "Tout exporter"
  }
}
